module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("路由")]), _vm._v(" "), _c('p', [_vm._v("推荐直接使用官方 "), _c('a', {
    attrs: {
      "href": "https://github.com/vuejs/vue-router"
    }
  }, [_vm._v("vue-router")]), _vm._v("，"), _c('code', [_vm._v("VUX")]), _vm._v("部分组件支持"), _c('code', [_vm._v("link")]), _vm._v("属性直接支持"), _c('code', [_vm._v("vue-router")]), _vm._v("的路由参数，"), _c('code', [_vm._v("vux2")]), _vm._v("模板内置了"), _c('code', [_vm._v("vue-router")]), _vm._v("。")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_c('del', [_vm._v("如果使用了过渡(转场动画)，在"), _c('code', [_vm._v("iPhone")]), _vm._v("上使用"), _c('code', [_vm._v("左划返回")]), _vm._v("时动画会再执行一遍，目前没有找到可行的处理方法，如果你有处理方案，欢迎"), _c('code', [_vm._v("PR")]), _vm._v("。")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/pull/2259"
    }
  }, [_vm._v("https://github.com/airyland/vux/pull/2259")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-73e7449e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-73e7449e"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/router-283.vue
// module id = 2332
// module chunks = 404